import { Diagnosesicherheit } from '../../mdqx-graphql-types';

export class DiagnosesicherheitEntity {
    public static readonly GqlFields = 'id kuerzel name';

    public Id: number;
    public Kuerzel: string;
    public Name: string;

    constructor(diagnosesicherheitType: Diagnosesicherheit | null) {
        if (
            diagnosesicherheitType &&
            diagnosesicherheitType.id != null &&
            diagnosesicherheitType.kuerzel != null &&
            diagnosesicherheitType.name != null
        ) {
            this.Id = diagnosesicherheitType.id;
            this.Kuerzel = diagnosesicherheitType.kuerzel;
            this.Name = diagnosesicherheitType.name;
        } else {
            console.error('received broken DiagnosesicherheitType', diagnosesicherheitType);
            throw Error();
        }
    }
}
